const data = {
  users: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'brandName',
        label: '品牌名称',
        width: '100'
      }, {
        prop: 'brandOperation',
        label: '运营企业',
        width: '100'
      }, {
        prop: 'brandContactPerson',
        label: '联系人',
        width: '100'
      }, {
        prop: 'brandContactMobile',
        label: '联系方式',
        width: '120'
      }, {
        prop: 'brandOperationNum',
        label: '运维人数',
        width: '100'
      }, {
        prop: 'brandBikeNum',
        label: '品牌核定自行车数',
        width: '100'
      }, {
        prop: 'brandEBikeNum',
        label: '品牌核定电动车数',
        width: '100'
      }, {
        prop: 'brandAddress',
        label: '联系地址',
        width: '120'
      }, {
        prop: 'areaId',
        label: '区域',
        width: '120'
      }, {
        fixed: 'right',
        label: '操作',
        width: '200'
      }
    ]
  },
  brandOperationNum: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      },
      {
        prop: 'maintainName',
        label: '姓名'
      }, {
        prop: 'maintainPhone',
        label: '联系方式'
      }, {
        prop: 'brandId',
        label: '工作单位'
      }, {
        prop: 'manageArea',
        label: '分管区域站点'
      }
    ]
  },
  brandBikeNum: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      },
      {
        prop: 'bikeId',
        label: '车辆编号'
      }, {
        prop: 'licenseCode',
        label: '车牌号'
      }, {
        prop: 'frameCode',
        label: '车架号'
      }, {
        prop: 'IMEICode',
        label: 'MAC码'
      }
    ]
  },
  brandEBikeNum: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      },
      {
        prop: 'bikeId',
        label: '车辆编号'
      }, {
        prop: 'licenseCode',
        label: '车牌号'
      }, {
        prop: 'frameCode',
        label: '车架号'
      }, {
        prop: 'IMEICode',
        label: 'MAC码'
      }
    ]
  },
  bikes: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'index',
        label: '序号',
        width: '30'
      },
      {
        prop: 'brandName',
        label: '品牌'
      },
      {
        prop: 'bikeId',
        label: '车辆编号'
      }, {
        prop: 'licenseNum',
        label: '车牌号'
      }, {
        prop: 'legality',
        label: '合法性'
      }
    ]
  }
}

export default data
